import { createAction, props, union } from '@ngrx/store';

import { CampaignConfig, EditorialPlanification } from '../../../mediego-common-module/declarations/campaign-config';

export const loadCampaigns = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Load',
  props<{ campaigns: CampaignConfig[] }>()
);

export const loadEditorialPlanifications = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Load editorial planifications',
  props<{ editorialPlanifications: EditorialPlanification[] }>()
);

export const addCampaign = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Add one',
  props<{ campaign: CampaignConfig }>()
);

export const updateCampaign = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Update one',
  props<{ id: string; partial: Partial<CampaignConfig> }>()
);

export const deleteCampaign = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Delete one',
  props<{ id: string }>()
);

export const deleteEditorialPlanification = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Delete editorial planification',
  props<{ timestamp: number }>()
);

export const toggleCampaignStatus = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Toggle status',
  props<{ id: string; status: boolean }>()
);

export const resetCampaigns = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Reset'
);

export const setActiveEditorialTimestamp = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Set active editorial timestamp',
  props<{ timestamp: number | null }>()
);

export const reloadEditorialPlanifications = createAction(
  '[NEWSLETTERS][CAMPAIGNS] Reload Editorial Planifications',
  props<{ engineId: number; sourceId: string }>()
);

const campaignActions = union({
  loadCampaigns,
  loadEditorialPlanifications,
  deleteCampaign,
  deleteEditorialPlanification,
  toggleCampaignStatus,
  resetCampaigns,
  setActiveEditorialTimestamp
});

export type CampaignAction = typeof campaignActions
